import React, {forwardRef} from 'react';
import Tippy from '@tippyjs/react';
import TippyJs from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import cx from 'classnames';
import Icon from '../Icon';

// resource - TippyJs documentation https://atomiks.github.io/tippyjs/v6/all-props

const hideOnEsc = {
    name: 'hideOnEsc',
    defaultValue: true,
    fn ( {hide} ) {
        function onKeyDown ( event ) {
            if ( event.keyCode === 27 ) {
                hide();
            }
        }

        return {
            onShow () {
                document.addEventListener( 'keydown', onKeyDown );
            },
            onHide () {
                document.removeEventListener( 'keydown', onKeyDown );
            }
        };
    }
};

const hideOnInteraction = {
    name: 'hideOnInteraction',
    defaultValue: true,
    fn ( api ) {
        const {popper, hide} = api;

        function onClick ( event ) {
            hide();
        }

        return {
            onShow () {
                popper.addEventListener( 'click', onClick );
            },
            onHide () {
                popper.removeEventListener( 'click', onClick );
            }
        };
    }
};

export const TooltipPlugins = {
    hideOnEsc,
    hideOnInteraction
};
const Tooltip = Tippy;
export default Tooltip;

export const tippy = TippyJs;

export const ShowTooltip = ( {tooltip, useIcon, iconName, className, children, ...props} ) => {
    if ( tooltip ) {
        return (
            <Tooltip content={tooltip} placement="top" offset={[0, 8]} {...props}>
                <span tabIndex="-1" className={cx( 'inline-block align-text-bottom', className )}>
                    {useIcon
                        ? <Icon name={iconName || 'Information'} width="16" className="inline-block ml-1"/>
                        : children}
                </span>
            </Tooltip>
        );
    }

    return useIcon ? null : children;
}

export const ContextMenu = ( {
                                 children,
                                 className,
                                 horizontal,
                                 label = 'Additional actions',
                                 placement = 'bottom-end'
                             } ) =>
    <Tippy plugins={hideOnEsc}
           trigger="click"
           maxWidth={480}
           arrow={false}
           placement={placement}
           interactive={true}
           theme="light"
           content={children}>
        <ContextMenu.Trigger label={label} horizontal={horizontal} className={className}/>
    </Tippy>

ContextMenu.Trigger = forwardRef( ( {label, horizontal, className}, ref ) =>
    <button ref={ref} className={cx( className, 'hover:link-2' )} aria-label={label}>
        <Tippy content={label} touch={false}>
            <span tabIndex="0">
                <ContextMenu.TriggerIcon horizontal={horizontal}/>
            </span>
        </Tippy>
    </button>
);

ContextMenu.TriggerIcon = forwardRef( ( {horizontal}, ref ) =>
    horizontal ?
        <Icon ref={ref} name={'MenuMoreHorizontal'} width="20"/> :
        <Icon ref={ref} name={'MenuMoreVertical'} width="20"/>
)

ContextMenu.Content = forwardRef( ( {children}, ref ) =>
    <div ref={ref} className="flex flex-col p-6 w-40 text-base">
        {children}
    </div>
);

